<template>
  <UserForm :user="user"
            :user-emails="user.user_emails"
            :user-mobile-numbers="user.user_mobile_numbers"
            :countries="countries"
            @formSubmit="formSubmitted($event)"
            @rankEmails="rankEmails($event)"
            @rankMobileNumbers="rankMobileNumbers($event)"
            @clickDestroy="anonymizeUser($event)" />
</template>

<script>
import store from "./UserStore";
import CountryStore from "../../../dashboard/stores/CountryStore";

import UserForm from "./UserForm.vue";
import UserMixin from "./UserMixin";

const responseStore = {
  response: null,
  countries: []
};

const fetchResource = async (to, from, next) => {
  responseStore.countries = await CountryStore.collection("public");

  next();
};

export default {
  name: "UserEdit",

  title () {
    return this.$t("common.editProfile") + ` - ${Dashboard.currentTenant.name}`;
  },

  components: {
    UserForm
  },

  beforeRouteEnter: fetchResource,
  beforeRouteUpdate: fetchResource,

  mixins: [UserMixin],

  data: function () {
    return {
      responseStore: responseStore
    };
  },

  computed: {
    countries () {
      return responseStore.countries;
    }
  },

  methods: {
    async formSubmitted (e) {
      this.handleResponseInplace(await store.update(this.user.id));
    },

    async anonymizeUser (e) {
      let responseJSON = await store.anonymizeUser(this.user);

      if (responseJSON.success) {
        location.reload();
      } else {
        this.notifyErrors(responseJSON.errorMessages);
      }
    },

    async rankEmails (e) {
      let responseJSON =
        await store.rankObject(e, "user_email");

      if (responseJSON.success) {
        this.notifySuccess(responseJSON.successMessage);
      } else {
        this.notifyErrors(responseJSON.errorMessages);
      }
    },

    async rankMobileNumbers (e) {
      let responseJSON =
        await store.rankObject(e, "user_mobile_number");

      if (responseJSON.success) {
        this.notifySuccess(responseJSON.successMessage);
      } else {
        this.notifyErrors(responseJSON.errorMessages);
      }
    }
  }
};
</script>
